export default "assets/images/logo-cafe-de-paris-big-en-a98587dc.png";